/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { historyClientControllerFindAllV1 } from '../fn/history-client/history-client-controller-find-all-v-1';
import { HistoryClientControllerFindAllV1$Params } from '../fn/history-client/history-client-controller-find-all-v-1';
import { HistoryDto } from '../models/history-dto';

@Injectable({ providedIn: 'root' })
export class HistoryClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `historyClientControllerFindAllV1()` */
  static readonly HistoryClientControllerFindAllV1Path = '/api/v1/histories/client';

  /**
   * 노출된 모든 History 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `historyClientControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyClientControllerFindAllV1$Response(params?: HistoryClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoryDto>>> {
    const obs = historyClientControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 노출된 모든 History 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `historyClientControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  historyClientControllerFindAllV1(params?: HistoryClientControllerFindAllV1$Params, context?: HttpContext): Observable<Array<HistoryDto>> {
    const resp = this.historyClientControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<HistoryDto>>): Array<HistoryDto> => r.body)
    );
  }

}
